import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import i18n from '@/configs/i18n'

const globalErrorHandler = (error: any) => {
  // 422 = Validation error, handled inline at field level — skip global toast
  if (error?.response?.status === 422) return

  const message =
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error?.message ||
    i18n.t('toast.something_went_wrong' as any)

  if (message === 'Invalid credentials.') return
  toast.error(message)
}

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (query?.meta?.suppressErrorToast) return
      globalErrorHandler(error)
    }
  }),

  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      if (mutation?.meta?.suppressErrorToast) return
      globalErrorHandler(error)
    }
  }),

  defaultOptions: {
    queries: {
      retry: 0,
      placeholderData: (previousData: any) => previousData,
      staleTime: 1000,
      refetchOnWindowFocus: true
    },
    mutations: {
      retry: 0
    }
  }
})

export default queryClient
